<template>
    <div class="block-contacts">
        <div class="block-contacts__header" v-if="$slots.title">
            <slot name="title"></slot>
        </div>
        <section class="block-contacts__section">
            <div class="block-contacts__col" v-if="$slots.first">
                <slot name="first"></slot>
            </div>
            <div class="block-contacts__col" v-if="$slots.second">
                <slot name="second"></slot>
            </div>
            <div class="block-contacts__col" v-if="$slots.third">
                <slot name="third"></slot>
            </div>
            <div class="block-contacts__col" v-if="$slots.fourth">
                <slot name="fourth"></slot>
            </div>
        </section>
        <section class="block-contacts__section">
            <div class="block-contacts__footer" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'block-contacts'
}
</script>

<style lang="scss">
    .block-contacts {
        $parent: &;

        &__header {
            padding: $token-spacers-s $token-spacers-s 0 $token-spacers-s;

            @include breakpoint (mobile) {
                padding: $token-spacers-xxs $token-spacers-xxs 0 $token-spacers-xxs;
            }
        }

        &__section {
            display: flex;
            flex-flow: row nowrap;
            align-items: stretch;
            justify-content: flex-start;

            @include breakpoint (v-tablet) {
                flex-flow: column nowrap;
            }
        }

        &__col {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
            justify-content: flex-start;
            flex-basis: 100%;
            padding: $token-spacers-s;
            position: relative;

            @include breakpoint (v-tablet) {
                .z-caption {
                    margin-bottom: $token-spacers-xxs;
                }

                .row > [class*="col-"] {
                    margin-top: $token-spacers-xxs;
                }
            }

            @include breakpoint (mobile) {
                padding: $token-spacers-xxs;
            }

            +#{$parent}__col:before {
                content: '';
                display: block;
                width: 2px;
                height: calc(100% - 64px);
                margin: auto;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                z-index: 1;
                background-color: $token-colors-black-20;

                @include breakpoint (v-tablet) {
                    width: calc(100% - #{$token-spacers-s});
                    height: 2px;
                    left: 0;
                    right: 0;
                    bottom: 100%;
                }
            }

            .z-icon {
                path {
                    fill: $token-colors-black-40;
                }
            }
        }

        &__footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: $token-spacers-s;
            flex-basis: 100%;

            @include breakpoint (v-tablet) {
                flex-direction: column;

                &>* + * {
                    margin-top: $token-spacers-xxs;
                }
            }
        }
    }
</style>
